var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartPie',{attrs:{"datasets":_vm.defaultDatasets,"labels":['Deviasi < -10%', 'Deviasi -1% s/d -10%', 'Deviasi > 0'],"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }